import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup } from 'reactstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ImageUploader from '../Common/ImageUploader';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyPatentes,
    getLegacyPersonas,
    getLegacyTiposTrabajoOt
} from '../../slices/thunks';
import ModalModificarVehiculo from './ModalModificarVehiculo';
import SignaturePad from '../SignaturePad';
import VehicleDamageForm from '../Common/VehicleDamageForm';
import FractionSlider from '../Common/FractionSlider';
import useMantenciones from '../Hooks/useMantenciones';


const ModalCrearRecepcionVehiculo = ({ isOpen, toggle, onSave, citaPrecargada, validationError }) => {
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)

    const modalContentRef = useRef(null);
    const [generandoPdf, setGenerandoPdf] = useState(false);
    const [saving, setSaving] = useState(false);
    const [saveMessage, setSaveMessage] = useState('');
    // INVENTARIO
    const [sin_inventario, setSinInventario] = useState(false)
    const [plumillas, setPlumillas] = useState(false)
    const [radio, setRadio] = useState(false)
    const [panel_radio, setPanelRadio] = useState(false)
    const [herramientas, setHerramientas] = useState(false)
    const [gata, setGata] = useState(false)
    const [extintor, setExtintor] = useState(false)
    const [botiquin, setBotiquin] = useState(false)
    const [permiso_circulacion, setPermisoCirculacion] = useState(false)
    const [libro_garantia, setLibroGarantia] = useState(false)
    const [encendedor, setEncendedor] = useState(false)
    const [accesorios, setAccesorios] = useState(false)
    const [neumatico_repuesto, setNeumaticoRepuesto] = useState(false)
    const [tapa_rueda, settapaRueda] = useState(false)
    const [cubre_pisos, setcubrePisos] = useState(false)

    // DAÑOS
    const [sin_danos, setSinDanos] = useState(false)
    const [tipoTrabajoOt, setTipoTrabajoOt] = useState({})
    const [sucio, setSucio] = useState(false)


    const [selectQuienRetira, setSelectQuienRetira] = useState({ value: 'propietario', label: 'Propietario' })
    const [selectedMantencion, setSelectedMantencion] = useState(null);

    const timeoutRef = useRef(null);

    const patentes = useSelector((state) => state.LegacyPatentes.legacyPatentes)
    const patentesIsLoading = useSelector((state) => state.LegacyPatentes.loading)
    const personas = useSelector((state) => state.LegacyPersonas.legacyPersonas)
    const personasIsLoading = useSelector((state) => state.LegacyPersonas.loading)

    const tiposTrabajoOt = useSelector((state) => state.LegacyTiposTrabajoOt.legacyTiposTrabajoOt)

    // Obtener marca y modelo de la patente cargada
    const marca = patentes?.[0]?.MARCAS || null;
    const modelo = patentes?.[0]?.MODELO || null;

    // Cargar mantenciones según marca y modelo
    const { mantenciones, loading: mantencionesLoading } = useMantenciones(marca, modelo);

    const dispatch = useDispatch()

    const [formData, setFormData] = useState({
        patente: citaPrecargada && citaPrecargada.patente ? citaPrecargada.patente : '',
        rut_contacto: citaPrecargada && citaPrecargada.rut_contacto ? citaPrecargada.rut_contacto : personas && personas.length > 0 ? personas[0].RUT : '',
        contacto: citaPrecargada && citaPrecargada.contacto ? citaPrecargada.contacto : personas && personas.length > 0 ? personas[0].NOMBRE : '',
        email: citaPrecargada && citaPrecargada.email ? citaPrecargada.email : personas && personas.length > 0 ? personas[0].EMAIL : '',
        telefono: citaPrecargada && citaPrecargada.telefono ? citaPrecargada.telefono : personas && personas.length > 0 ? personas[0].TELEFONO : '',
        cita: citaPrecargada && citaPrecargada.cita ? citaPrecargada.cita : 0,
        tipo_trabajo_ot: citaPrecargada && citaPrecargada.tipo_trabajo_ot ? citaPrecargada.tipo_trabajo_ot : '',
        solicitud_cliente: citaPrecargada && citaPrecargada.solicitud_cliente ? citaPrecargada.solicitud_cliente : '',
        sin_inventario: false,
        sin_danos: false,
        sucio: false,
        nivel_estanque: 0,
        emisora_radio: "",
        inventario: {
            plumillas: false,
            radio: false,
            panel_radio: false,
            herramientas: false,
            gata: false,
            extintor: false,
            botiquin: false,
            permiso_circulacion: false,
            libro_garantia: false,
            encendedor: false,
            accesorios: false,
            neumatico_repuesto: false,
            tapa_rueda: false,
            cubre_pisos: false,
            observaciones: '',
        },
        danos: [],
        danos_img: '',
        firma_cliente: '',
        firma_recepcionista: '',
        nombre_recepcionista: userInfo && userInfo.displayName ? userInfo.displayName : '',
        imagenes: [],
        quien_retira: personas && personas.length > 0 ? personas[0].NOMBRE : ''
    });

    useEffect(() => {
        if (userInfo && userInfo.displayName) {
            setFormData(prevData => ({
                ...prevData,
                ['nombre_recepcionista']: userInfo.displayName
            }));
        }
    }, [userInfo])

    useEffect(() => {
        if (citaPrecargada && citaPrecargada.patente) {
            dispatch(getLegacyPatentes({ tenantId, patente: citaPrecargada.patente, empresa }))
        }


        if (citaPrecargada && citaPrecargada.tipo_trabajo_ot)
            setTipoTrabajoOt(parseTiposTrabajoOt(buscarTipoTrabajoOt(citaPrecargada.tipo_trabajo_ot)))
        else
            setTipoTrabajoOt(parseTiposTrabajoOt(tiposTrabajoOt[0]))


    }, [citaPrecargada])

    useEffect(() => {
        if (selectQuienRetira && selectQuienRetira.value == 'propietario') {
            setFormData(prev => ({
                ...prev,
                ["quien_retira"]: personas && personas.length > 0 ? personas[0].NOMBRE : ''
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                ["quien_retira"]: ''
            }));
        }
    }, [selectQuienRetira])


    useEffect(() => {
        if (Array.isArray(patentes) && patentes.length > 0) {
            dispatch(getLegacyPersonas({ tenantId, rut: patentes[0]?.CLIENT || '', empresa }))
        }
    }, [patentes])

    useEffect(() => {
        if (tiposTrabajoOt.length === 0)
            dispatch(getLegacyTiposTrabajoOt({ tenantId, empresa }))
    }, [tiposTrabajoOt])


    useEffect(() => {
        if (Array.isArray(personas) && personas.length > 0) {
            setFormData(prev => ({
                ...prev,
                ["rut_contacto"]: personas[0].CLIPRO || '',
                ["contacto"]: personas[0].CONTAC || '',
                ["email"]: personas[0].CEMAIL || '',
                ["telefono"]: personas[0].NFONO1 || '',
                ["quien_retira"]: personas[0].CONTAC || ''
            }));

        }
    }, [personas])

    useEffect(() => {
        if (isOpen) {
            setFormData({
                patente: citaPrecargada && citaPrecargada.patente ? citaPrecargada.patente : '',
                rut_contacto: citaPrecargada && citaPrecargada.rut_contacto ? citaPrecargada.rut_contacto : personas && personas.length > 0 ? personas[0].RUT : '',
                contacto: citaPrecargada && citaPrecargada.contacto ? citaPrecargada.contacto : personas && personas.length > 0 ? personas[0].NOMBRE : '',
                email: citaPrecargada && citaPrecargada.email ? citaPrecargada.email : personas && personas.length > 0 ? personas[0].EMAIL : '',
                telefono: citaPrecargada && citaPrecargada.telefono ? citaPrecargada.telefono : personas && personas.length > 0 ? personas[0].TELEFONO : '',
                cita: citaPrecargada && citaPrecargada.cita ? citaPrecargada.cita : 0,
                tipo_trabajo_ot: citaPrecargada && citaPrecargada.tipo_trabajo_ot ? citaPrecargada.tipo_trabajo_ot : '',
                solicitud_cliente: citaPrecargada && citaPrecargada.solicitud_cliente ? citaPrecargada.solicitud_cliente : '',
                sin_inventario: false,
                sin_danos: false,
                sucio: false,
                nivel_estanque: 0,
                emisora_radio: "",
                inventario: {
                    plumillas: false,
                    radio: false,
                    panel_radio: false,
                    herramientas: false,
                    gata: false,
                    extintor: false,
                    botiquin: false,
                    permiso_circulacion: false,
                    libro_garantia: false,
                    encendedor: false,
                    accesorios: false,
                    neumatico_repuesto: false,
                    tapa_rueda: false,
                    cubre_pisos: false,
                    observaciones: '',
                },
                danos: [],
                danos_img: '',
                firma_cliente: '',
                firma_recepcionista: '',
                nombre_recepcionista: userInfo && userInfo.displayName ? userInfo.displayName : '',
                imagenes: [],
                quien_retira: personas && personas.length > 0 ? personas[0].NOMBRE : ''
            });
        }
    }, [isOpen]);

    const handleInputChange = (e) => {
        if (e?.target) {
            const { name, value, checked } = e.target;
            switch (name) {
                case 'patente':
                    let patente = value.trim().toUpperCase()
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: patente
                    }));
                    if (patente.length >= 5) {
                        if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current)
                        }
                        timeoutRef.current = setTimeout(() => {
                            dispatch(getLegacyPatentes({ tenantId, patente, empresa }))
                        }, 300)
                    }
                    break
                case 'rut':
                    let rut = value.trim()
                    if (rut.length >= 5) {
                        formData.rut = rut
                    }
                    break
                case 'sin_inventario':
                    setSinInventario(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: checked
                    }));
                    break
                case 'plumillas':
                    setPlumillas(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'radio':
                    setRadio(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'panel_radio':
                    setPanelRadio(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'herramientas':
                    setHerramientas(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'gata':
                    setGata(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'extintor':
                    setExtintor(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'botiquin':
                    setBotiquin(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'permiso_circulacion':
                    setPermisoCirculacion(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'libro_garantia':
                    setLibroGarantia(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'encendedor':
                    setEncendedor(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'accesorios':
                    setAccesorios(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'neumatico_repuesto':
                    setNeumaticoRepuesto(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'tapa_rueda':
                    settapaRueda(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'cubre_pisos':
                    setcubrePisos(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            [name]: checked
                        }
                    }));
                    break
                case 'observaciones_inventario':
                    setcubrePisos(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        inventario: {
                            ...prevData.inventario,
                            observaciones: checked
                        }
                    }));
                    break
                case 'sin_danos':
                    setSinDanos(checked)
                    if (checked) {
                        setFormData(prevData => ({
                            ...prevData,
                            ['rayado']: false,
                            ['abollado']: false,
                            ['piquete']: false,
                            ['falta']: false,
                            ['sucio']: false,
                        }));
                    }
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: checked
                    }));
                    break
                case 'sucio':
                    setSucio(checked)
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: checked
                    }));
                    break
                default:
                    setFormData(prevData => ({
                        ...prevData,
                        [name]: value
                    }));
                    break;
            }
        }
    }

    const handleDanosChange = (base64) => {
        setFormData(prev => ({
            ...prev,
            danos_img: base64
        }));
    };

    const handleSelectTiposTrabajoOt = (opcion) => {
        setTipoTrabajoOt(opcion);
        setFormData(prev => ({
            ...prev,
            tipo_trabajo_ot: opcion.value
        }));
    };

    function buscarTipoTrabajoOt(codigo) {
        let trabajoEncontrado = {}
        if (Array.isArray(tiposTrabajoOt) && tiposTrabajoOt.length > 0) {
            trabajoEncontrado = tiposTrabajoOt?.find(m => m.CODREG == codigo)
        }
        return trabajoEncontrado
    }

    const handleImagesChange = (nuevasImagenes) => {
        setFormData(prev => ({
            ...prev,
            imagenes: nuevasImagenes
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setSaveMessage('');
        try {
            const result = await onSave(formData);
            if (result.success) {
                setSaveMessage('Recepción creada exitosamente.');
                setTimeout(() => {
                    toggle();
                }, 2000); // Close after 2 seconds
            } else {
                setSaveMessage('Error al crear la recepción: ' + (result.error || 'Error desconocido'));
            }
        } catch (error) {
            setSaveMessage('Error al crear la recepción: ' + error.message);
        } finally {
            setSaving(false);
        }
    };

    const handleCancel = () => {
        toggle();
    };

    const handleFuelChange = (fuelValue) => {
        setFormData(prev => ({
            ...prev,
            nivel_estanque: fuelValue
        }));
    };

    const handleSignatureClienteChange = (signatureData) => {
        setFormData(prev => ({
            ...prev,
            firma_cliente: signatureData
        }));
        console.log(formData)
    };

    const handleSignatureRecepcionistaChange = (signatureData) => {
        setFormData(prev => ({
            ...prev,
            firma_recepcionista: signatureData,
        }));
        console.log(formData)
    };

    function parseTiposTrabajoOt(tipo_trabajo_ot) {
        return { value: tipo_trabajo_ot?.CODREG, label: tipo_trabajo_ot?.DESCRI };
    }

    // Parsear mantenciones para el Select
    const parseMantenciones = (mantenciones) => {
        if (!Array.isArray(mantenciones)) return [];
        return mantenciones.map(m => ({
            value: m.clave,  // Campo clave del backend (identificador único)
            label: m.descri_pieza,  // Texto mostrado al usuario
            data: m  // guardar toda la data por si se necesita
        }));
    };

    // Handler para selección de mantención
    const handleSelectMantencion = (opcion) => {
        setSelectedMantencion(opcion);
        setFormData(prev => ({
            ...prev,
            servicio: opcion ? opcion.value : ''
        }));
    };

    const [cameraOpen, setCameraOpen] = useState(false);

    // Cerrar modal temporalmente cuando la cámara está abierta
    const effectiveIsOpen = isOpen && !cameraOpen;

    // ******************Modal Modificar Vehiculo
    const [modalModificarVehiculo, setModalModificarVehiculo] = useState(false)
    const toggleModalVehiculo = () => {
        setModalModificarVehiculo(!modalModificarVehiculo);
    };

    const handleModalModificarVehiculo = () => {
        setModalModificarVehiculo(true);
    }

    const handleGuardarVehiculo = (datosVehiculo) => {
        // Ejemplo de guardado
        const nuevaRecepcion = {
            id: Date.now(),
            ...datosVehiculo,
            fechaCreacion: new Date().toISOString()
        };

        // Actualizar el estado de recepciones
        //setRecepciones(prev => [...prev, nuevaRecepcion]);

        // Mostrar mensaje de éxito
        //alert('Vehiculo creado exitosamente');

        // llamar al hook para guardar vehículo
        //
    };

    return (
        <Modal isOpen={effectiveIsOpen} toggle={toggle} size="lg">
            <div ref={modalContentRef} >
                <ModalHeader toggle={toggle}>
                    <i className="ri-car-line me-2"></i>
                    Nueva Recepción de Vehículo
                </ModalHeader>
                <Form>
                    <ModalBody>
                        <ModalModificarVehiculo
                            isOpen={modalModificarVehiculo}
                            toggle={toggleModalVehiculo}
                            onSave={handleGuardarVehiculo}
                            patente={Array.isArray(patentes) && patentes.length > 0 ? patentes[0] : {}}
                        />



                        {!personasIsLoading ? (
                            <>
                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted fw-bold">Datos de contacto</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <FormGroup>
                                            <Label for="contacto">Nombre contacto</Label>
                                            <Input
                                                type="text"
                                                id="contacto"
                                                name="contacto"
                                                value={formData.contacto}
                                                onChange={handleInputChange}
                                                placeholder="Ej: Jorge Gonzalez"
                                            />
                                        </FormGroup>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="email">Email</Label>
                                            <Input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                placeholder="Ej: correo@ejemplo.cl"
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-6">
                                        <FormGroup>
                                            <Label for="telefono">Teléfono</Label>
                                            <Input
                                                type="text"
                                                id="telefono"
                                                name="telefono"
                                                value={formData.telefono}
                                                onChange={handleInputChange}
                                                placeholder="Ej: 987654321"
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                </div>

                            </>) : <></>}

                        <div className="d-flex align-items-center my-2">
                            <div className="flex-grow-1 border-top"></div>
                            <span className="mx-3 text-muted fw-bold">Vehículo</span>
                            <div className="flex-grow-1 border-top"></div>
                        </div>
                        <div className="row  align-items-end">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="patente">Patente</Label>
                                    <div className="row">
                                        <div className="col">
                                            <Input
                                                type="text"
                                                id="patente"
                                                name="patente"
                                                value={formData.patente}
                                                onChange={handleInputChange}
                                                placeholder="Ej: ABC123"
                                                required
                                            />
                                        </div>
                                        {patentesIsLoading ?
                                            <div className="col">
                                                <div><Label>Cargando...</Label></div>
                                            </div> : (
                                                Array.isArray(patentes) && patentes.length > 0 ? (
                                                    <div className="col">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={handleModalModificarVehiculo}
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        ><i className="ri-add-line me-1"></i> Modificar
                                                        </button>
                                                    </div>
                                                ) : formData.patente && typeof formData.patente == 'string' && formData.patente.length > 4 ? (
                                                    <div className="col">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={handleModalModificarVehiculo}
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        ><i className="ri-add-line me-1"></i> Crear
                                                        </button>
                                                    </div>
                                                ) : "")}
                                    </div>

                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="odometro">Odómetro</Label>
                                    <Input
                                        type="number"
                                        id="odometro"
                                        name="odometro"
                                        value={formData.odometro}
                                        onChange={handleInputChange}
                                        placeholder={`Último registro: ${patentes[0]?.ULTLEM || '0'} km`}
                                        required
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row  align-items-end">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="emisora_radio">Emisora radio</Label>
                                    <Input
                                        type="text"
                                        id="emisora_radio"
                                        name="emisora_radio"
                                        value={formData.emisora_radio}
                                        onChange={handleInputChange}
                                        placeholder="Ej: 88.1 FM"
                                        required
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-6">

                                <FormGroup>
                                    <Label for="tipo_trabajo">Tipo Trabajo</Label>
                                    <Select
                                        id="tipo_trabajo"
                                        placeholder="Seleccione..."
                                        value={tipoTrabajoOt}
                                        onChange={handleSelectTiposTrabajoOt}
                                        options={Array.isArray(tiposTrabajoOt) && tiposTrabajoOt.length > 0 ? tiposTrabajoOt?.map(parseTiposTrabajoOt) : []}
                                        onFocus={(e) => {
                                            e.target.readOnly = true;
                                        }}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="nivel_combustible">Combustible</Label>
                                    <FractionSlider
                                        value={formData.nivel_estanque}
                                        onChange={handleFuelChange}
                                    />
                                </FormGroup>
                            </div>
                            {tipoTrabajoOt?.value == 'MAN' && formData.patente && (
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="servicio">Servicio</Label>
                                        {mantencionesLoading ? (
                                            <div className="text-muted">Cargando mantenciones...</div>
                                        ) : mantenciones.length > 0 ? (
                                            <Select
                                                id="servicio"
                                                name="servicio"
                                                placeholder="Seleccione mantención..."
                                                value={selectedMantencion}
                                                onChange={handleSelectMantencion}
                                                options={parseMantenciones(mantenciones)}
                                                isClearable
                                            />
                                        ) : (
                                            <Input
                                                type="text"
                                                id="servicio"
                                                name="servicio"
                                                value={formData.servicio}
                                                onChange={handleInputChange}
                                                placeholder="No hay mantenciones disponibles"
                                            />
                                        )}
                                    </FormGroup>
                                </div>
                            )}
                        </div>

                        <div className="row">
                            <div className="col">
                                <FormGroup>
                                    <Label for="solicitud_cliente">Solicitud cliente</Label>
                                    <Input
                                        type="textarea"
                                        id="solicitud_cliente"
                                        name="solicitud_cliente"
                                        value={formData.solicitud_cliente}
                                        onChange={handleInputChange}
                                        rows="3"
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <Label for="sin_inventario">Sin inventario</Label>
                            </div>
                            <div className="col-6">
                                <Input
                                    type="checkbox"
                                    id="sin_inventario"
                                    name="sin_inventario"
                                    checked={sin_inventario}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        {!sin_inventario ? (
                            <>

                                <div className="d-flex align-items-center my-2">
                                    <div className="flex-grow-1 border-top"></div>
                                    <span className="mx-3 text-muted fw-bold">Inventario</span>
                                    <div className="flex-grow-1 border-top"></div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-6">
                                        <Label for="plumillas">Plumillas</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="plumillas"
                                            name="plumillas"
                                            checked={plumillas}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="radio">Radio</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="radio"
                                            name="radio"
                                            checked={radio}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="panel_radio">Panel radio</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="panel_radio"
                                            name="panel_radio"
                                            checked={panel_radio}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="herramientas">Herramientas</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="herramientas"
                                            name="herramientas"
                                            checked={herramientas}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="gata">Gata</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="gata"
                                            name="gata"
                                            checked={gata}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="extintor">Extintor</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="extintor"
                                            name="extintor"
                                            checked={extintor}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="botiquin">Botiquín</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="botiquin"
                                            name="botiquin"
                                            checked={botiquin}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="permiso_circulacion">Permiso circulación</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="permiso_circulacion"
                                            name="permiso_circulacion"
                                            checked={permiso_circulacion}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="libro_garantia">Libro garantía</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="libro_garantia"
                                            name="libro_garantia"
                                            checked={libro_garantia}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="encendedor">Encendedor</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="encendedor"
                                            name="encendedor"
                                            checked={encendedor}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="accesorios">Accesorios</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="accesorios"
                                            name="accesorios"
                                            checked={accesorios}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="neumatico_repuesto">Neumático repuesto</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="neumatico_repuesto"
                                            name="neumatico_repuesto"
                                            checked={neumatico_repuesto}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="tapa_rueda">Tapa rueda</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="tapa_rueda"
                                            name="tapa_rueda"
                                            checked={tapa_rueda}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <Label for="cubre_pisos">Cubre pisos</Label>
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            type="checkbox"
                                            id="cubre_pisos"
                                            name="cubre_pisos"
                                            checked={cubre_pisos}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <FormGroup>
                                        <Label for="observaciones_inventario">Observaciones de inventario</Label>
                                        <Input
                                            type="textarea"
                                            id="observaciones_inventario"
                                            name="observaciones_inventario"
                                            value={formData.inventario.observaciones}
                                            onChange={handleInputChange}
                                            placeholder="Observaciones adicionales..."
                                            rows="3"
                                        />
                                    </FormGroup>
                                </div>
                            </>
                        ) : ''}


                        <div className="row">
                            <div className="col-6">
                                <Label for="sin_danos">Sin daños aparentes</Label>
                            </div>
                            <div className="col-6">
                                <Input
                                    type="checkbox"
                                    id="sin_danos"
                                    name="sin_danos"
                                    checked={sin_danos}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>



                        {!sin_danos ? <>
                            <div className="d-flex align-items-center my-2">
                                <div className="flex-grow-1 border-top"></div>
                                <span className="mx-3 text-muted fw-bold">Daños</span>
                                <div className="flex-grow-1 border-top"></div>
                            </div>
                            <VehicleDamageForm
                                danos={formData.danos}
                                onDanosChange={handleDanosChange}
                            />


                        </> : <></>}

                        <div className="row">
                            <div className="col-6">
                                <Label for="sucio">Vehículo sucio</Label>
                            </div>
                            <div className="col-6">
                                <Input
                                    type="checkbox"
                                    id="sucio"
                                    name="sucio"
                                    checked={sucio}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center my-2">
                            <div className="flex-grow-1 border-top"></div>
                            <span className="mx-3 text-muted fw-bold">Imágenes</span>
                            <div className="flex-grow-1 border-top"></div>
                        </div>
                        <ImageUploader
                            onImagesChange={handleImagesChange}
                            maxImages={10}
                            existingImages={formData.imagenes}
                            onCameraOpen={setCameraOpen}
                        />

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="cliente">Cliente</Label>
                                    <Input
                                        type="text"
                                        id="contacto"
                                        name="contacto"
                                        value={formData.contacto}
                                        onChange={handleInputChange}
                                        placeholder="Ej: Jorge Gonzalez"
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="nombre_recepcionista">Recepcionista</Label>
                                    <Input
                                        type="text"
                                        id="nombre_recepcionista"
                                        name="nombre_recepcionista"
                                        value={formData.nombre_recepcionista}
                                        onChange={handleInputChange}
                                        placeholder={`Ej: Miguel Tapia`}
                                        required
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label>Firma cliente</Label>
                                    <SignaturePad
                                        width={500}
                                        height={200}
                                        lineColor="#000000"
                                        lineWidth={2}
                                        clearButtonText="Limpiar"
                                        onSignatureChange={handleSignatureClienteChange}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-6">
                                <FormGroup>
                                    <Label>Firma recepcionista</Label>
                                    <SignaturePad
                                        width={500}
                                        height={200}
                                        lineColor="#000000"
                                        lineWidth={2}
                                        clearButtonText="Limpiar"
                                        onSignatureChange={handleSignatureRecepcionistaChange}
                                    />
                                </FormGroup>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <FormGroup>
                                    <Label for="select_quien_retira">Quien retira?</Label>
                                    <Select
                                        id="select_quien_retira"
                                        name="select_quien_retira"
                                        placeholder="Seleccione..."
                                        value={selectQuienRetira}
                                        onChange={setSelectQuienRetira}
                                        options={[
                                            { value: 'propietario', label: 'Propietario' },
                                            { value: 'otro', label: 'Otro' }
                                        ]}
                                        onFocus={(e) => {
                                            e.target.readOnly = true;
                                        }}
                                    />
                                </FormGroup>
                            </div>
                            {selectQuienRetira && selectQuienRetira.value === 'otro' ? (
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="quien_retira">Otro</Label>
                                        <Input
                                            type="text"
                                            id="quien_retira"
                                            name="quien_retira"
                                            value={formData.quien_retira}
                                            onChange={handleInputChange}
                                            placeholder={`Ej: Nombre de la persona`}
                                            required
                                        />
                                    </FormGroup>
                                </div>) : null}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-light" onClick={handleCancel}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-success" onClick={handleSubmit} disabled={generandoPdf || saving}>
                            {saving ? (
                                <>
                                    <i className="ri-loader-4-line ri-spin-line me-1"></i>
                                    Guardando...
                                </>
                            ) : generandoPdf ? (
                                <>
                                    <i className="ri-loader-4-line ri-spin-line me-1"></i>
                                    Generando PDF...
                                </>
                            ) : (
                                <>
                                    <i className="ri-save-line me-1"></i>
                                    Guardar Recepción
                                </>
                            )}
                        </button>
                        {(validationError || saveMessage) && (
                            <div className={`mt-2 w-100 text-center ${saveMessage.includes('exitosamente') ? 'text-success' : 'text-danger'}`}>
                                {validationError || saveMessage}
                            </div>
                        )}
                    </ModalFooter>
                </Form>
            </div>
        </Modal>
    );
};

export default ModalCrearRecepcionVehiculo;